import { generatePath, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { ExtendedTasksResponse } from 'app/console-api/tasks/tasks-extended';
import { getTaskById } from 'app/console-api';
import { HttpError } from 'app/components/utils/http-error';
import { statusCode } from 'app/constants';
import { APPS_TASKS_VIEW_PATH, SIGN_IN_PATH } from 'app/route/paths';
import { SkeletonLoader } from 'app/components/common/skeleton-loader/skeleton-loader';
import { PageContainer } from 'app/components/common/common-styles';
import { TaskEditForm } from 'app/components/management/apps/tasks/edit/task-edit-form';
import { useTabsCtx } from 'app/components/management/apps/tabs-page-layout';
import { FlexRow } from '@make-software/cspr-design';

export const TaskEditPage = () => {
  const { appID, setBreadcrumbs } = useTabsCtx();
  const { id } = useParams<{ id: string }>();
  const [task, setTask] = useState<ExtendedTasksResponse | null>(null);

  useEffect(() => {
    if (!id) {
      console.error('No ID provided in the route.');
      return;
    }
    getTaskById(appID, id)
      .then((response) => {
        setTask(response);
        setBreadcrumbs([
          {
            label: response.task.name,
            to: generatePath(APPS_TASKS_VIEW_PATH, { appID, id: response.task.id })
          },
          {
            label: 'Edit'
          }
        ]);
      })
      .catch((error: any) => {
        if (error instanceof HttpError) {
          if (error.statusCode === statusCode.authentication_error) {
            window.location.href = SIGN_IN_PATH;
            return;
          }
        }
        console.error('Failed to fetch task:', error);
      });
    return () => setBreadcrumbs([]);
  }, []);

  if (!task) {
    return (
      <PageContainer>
        <SkeletonLoader height={'300px'} />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <FlexRow justify={'center'} align={'center'}>
        <TaskEditForm task={task} />
      </FlexRow>
    </PageContainer>
  );
};
